import { BrowserRouter as Router } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export default function AppRouterProvider(props: Props) {
  return <Router>{props.children}</Router>;
}
